var _rect, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirstPodium = function SvgFirstPodium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 38,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#first-podium_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 22,
    x: 8,
    y: 8,
    fill: "#0C0C0F",
    fillOpacity: 0.4,
    rx: 8,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "first-podium_svg__b",
    width: 16,
    height: 16,
    x: 14,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M14 11h16v16H14z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#first-podium_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#first-podium_svg__c)",
    d: "M18.928 12.793h6.143v4.744q0 .27-.137.54a1.07 1.07 0 0 1-.384.426l-2.253 1.708.396 1.292h2.11l-1.741 1.226.678 2.133L22 23.54l-1.74 1.322.677-2.138-1.74-1.22h2.11l.395-1.293-2.265-1.695a1.1 1.1 0 0 1-.376-.431 1.2 1.2 0 0 1-.133-.549zm.866.867v3.877q0 .112.04.184a.3.3 0 0 0 .14.123l1.592 1.153V13.66zm4.41 0h-1.771v5.337l1.592-1.153q.117-.051.148-.123a.5.5 0 0 0 .032-.184z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#first-podium_svg__d)",
    d: "M35.056 24v-.888h2.34v-6.744h-.084L35.2 18.336l-.588-.636 2.22-2.076h1.572v7.488h2.16V24zm10.807.144q-1.02 0-1.74-.384a3.76 3.76 0 0 1-1.224-1.08l.744-.624q.444.588.984.9.54.3 1.272.3.9 0 1.368-.432.48-.432.48-1.152 0-.6-.36-.924t-1.188-.516l-.684-.156q-1.152-.264-1.764-.792-.6-.54-.6-1.512 0-.552.204-.984t.564-.72q.372-.288.876-.432.516-.156 1.128-.156.948 0 1.62.348.684.348 1.152 1.02l-.756.552a2.6 2.6 0 0 0-.84-.756q-.492-.276-1.224-.276-.804 0-1.272.348-.456.336-.456 1.02 0 .6.384.912.396.3 1.188.48l.684.156q1.236.276 1.788.84t.552 1.5q0 .576-.204 1.044a2.1 2.1 0 0 1-.564.792 2.6 2.6 0 0 1-.912.504 3.7 3.7 0 0 1-1.2.18m8.489-7.632V24h-1.008v-7.488H50.68v-.888h6.336v.888z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "first-podium_svg__c",
    x1: 22,
    x2: 22,
    y1: 12.793,
    y2: 24.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "first-podium_svg__d",
    x1: 46,
    x2: 46,
    y1: 10,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA00"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "first-podium_svg__a",
    width: 74,
    height: 38,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886275 0 0 0 0 0.811765 0 0 0 0 0.00392157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18619_196313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_18619_196313",
    result: "shape"
  })))));
};
export default SvgFirstPodium;